import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import Button from '@material-ui/core/Button'

import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import CircularProgress from '@material-ui/core/CircularProgress'

import { StepOne, StepTwo, StepThree, EnrollmentsProcess } from './Index'

import { updateSetupProgress } from '../../actions'

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative'
  },
  layout: {
    width: 'auto',
    marginTop: theme.spacing(5),

    [theme.breakpoints.up(1000 + theme.spacing(2) * 2)]: {
      width: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(1000 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  stepper: {
    padding: theme.spacing(3, 0, 5)
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1)
  }
}))

const steps = ['Programme and Term', 'Review and Process']

function getStepContent(step) {
  switch (step) {
    case 0:
      return <StepOne /> //<EnrollmentsProcess />;//
    case 1:
      return <StepThree />

    default:
      throw new Error('Unknown step')
  }
}

const CourseLevelAdminHome = (props) => {
  const classes = useStyles()

  const [activeStep, setActiveStep] = React.useState(0)
  const [open, setOpen] = React.useState(false)
  const [dialogTitle, setDialogTitle] = React.useState('')
  const [dialogText, setDialogText] = React.useState('')

  const { data } = props

  const [value, setValue] = React.useState(0)

  let isProgrammeSelected = data.summery.data.filter(
    (data) => data.value == 'prog'
  )

  let isTermsSelected = data.selectedTerms.data

  let isSubAccountSelected = data.selectedSubAccount.data

  let isRoleSelected = data.summery.data.filter((data) => data.value == 'role')

  let isCoursesSelected = data.summery.courses

  let isUsersVerified =
    data.courseSectionUserData.data.length != 0 ? true : false

  let selectActionType = data.csvActionType

  const handleNext = () => {
    let isUsersSelected = data.summery.userstext
    let isMultipleUsers = false

    if (isUsersSelected.indexOf(',') > -1) {
      isUsersSelected = isUsersSelected.split(',')
      isMultipleUsers = true
    }

    if (isProgrammeSelected.length == 0 && activeStep == 0) {
      setDialogTitle('Warning!!')
      setDialogText('Please select programme and the term')
      setOpen(true)
      return false
    }

    if ((isCoursesSelected.length == 0) & (activeStep == 0)) {
      setDialogTitle('Warning!!')
      setDialogText('Please select courses to proceed next')
      setOpen(true)
      return false
    } else if (activeStep == 0) {
      setActiveStep(activeStep + 1)
      props.updateSetupProgress(activeStep + 1)
      return false
    }

    if (isUsersVerified === false) {
      setDialogTitle('Warning!!')
      setDialogText(
        'Unable to find users in the Canvas. Please go back and edit email list.'
      )
      setOpen(true)
    } else {
      setActiveStep(activeStep + 1)
    }
  }

  const handleBack = () => {
    let progreess = activeStep - 1
    props.updateSetupProgress(progreess)
    setActiveStep(progreess)
  }

  const handleClickOpen = () => {
    // setOpen(true);
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <React.Fragment>
      <Typography component='h1' variant='h5' align='center'>
        {' '}
        Section Enrollment{' '}
      </Typography>

      <Stepper activeStep={activeStep} className={classes.stepper}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <React.Fragment>
        {activeStep === steps.length ? (
          <EnrollmentsProcess />
        ) : (
          <React.Fragment>
            {getStepContent(activeStep)}
            <div className={classes.buttons}>
              {activeStep !== 0 && (
                <Button onClick={handleBack} className={classes.button}>
                  Back
                </Button>
              )}
              <Button
                variant='contained'
                color='primary'
                onClick={handleNext}
                className={classes.button}
                disabled={
                  data.users.req != data.users.org && activeStep == 2
                    ? true
                    : false
                }
              >
                {data.users.req != data.users.org && activeStep == 2 ? (
                  <CircularProgress size={24} />
                ) : (
                  ''
                )}

                {activeStep === steps.length - 1
                  ? 'Submit Data to LMS'
                  : 'Next'}
              </Button>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {' '}
            {dialogText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary' autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  return {
    data: state.CourseLevelAdmin
  }
}

export default connect(mapStateToProps, { updateSetupProgress })(
  CourseLevelAdminHome
)
